<template>
<div
    class="actionCard" 
    @click="goToHref" 
    :class="{
        'blue': this.bgColor === 'blue',
        'pink': this.bgColor === 'pink',
        'teal': this.bgColor === 'teal',
    }"
    :style="`
        cursor: ${this.href || this.action ? 'pointer' : 'default' }
    `"
>
    <header v-if="hasHeader" :style="`background-image: url(${image})`">
        <slot name="header" v-if="!image" />
    </header>
    <main v-if="hasBody">
        <slot name="body" />
    </main>
    <footer v-if="hasFooter">
        <slot name="footer" />
    </footer>
    <a :href="href" ref="link" class="hiddenLink"></a>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    props: ['bg-color', 'href', 'action', 'location', 'image'],
    computed: {
        ...mapState([]),
        hasHeader() {
            return !!this.$slots['header']
        },
        hasBody() {
            return !!this.$slots['body']
        },
        hasFooter() {
            return !!this.$slots['footer']
        },
    },
    methods: {
        ...mapActions([]),
        goToHref(e) {
            if (this.action) {
                return this.action(this.location, e)
            }
            const url = this.href
            if (url === '/resources') { mixpanel.track('selectedResources', {location: 'card'}) }
            if (url === '/faq') { mixpanel.track('WhyUs', {location: 'card'}) }
            if (url) {
                if (e.ctrlKey || e.metaKey) {
                    console.log('ctl')
                    $('<a href="' + url + '" target="_blank"></a>')[0].click()
                } else {
                    document.location = url
                }
                return false
            }
        },
    },
}
</script>

<style lang="scss">
.actionCard {
    display: flex;
    flex-direction: column;
    background: #ffffff;
    justify-content: center;
    color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    font-size: 1em;
}

.hiddenLink {
    display: none;
}

.actionCard.blue {
    background-color: #00528f;
}
.actionCard.blue main {
    background-color: #4d92c6;
}
.actionCard.pink {
    background-color: #cd609e;
}
.actionCard.pink main {
    background-color: #f2a4d0;
}
.actionCard.teal {
    background-color: #13bdd4;
}
.actionCard.teal main {
    background-color: #8dedfa;
}

.actionCard main {
    flex-grow: 1;
    border-radius: 8px 8px 0 0;
    height: 13em;
}
.actionCard footer {
    padding: 1em 1.5em 1em;
}

.actionCard header {
    position: relative;
    z-index: 0;
    height: 13.5em;
    overflow: hidden;
    border-radius: 8px 8px 0 0;
    background: rgba(#000000, .1);
    background-size: cover;
    background-position: center;
}

.actionCard header img {
    display: block;
    width: 100%;
    border-radius: 8px 8px 0 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
}

.actionCard main h3 {
    color: #000000;
    font-size: 1.2em;
    font-weight: 700;
    margin: 0 0 0 0;
}
</style>

